import * as React from 'react'
import { ReactElement } from 'react'
import Card from '../../../components/Card'
import { CommandBarButton, Stack, StackItem } from '@fluentui/react'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { useHistory } from 'react-router-dom'
import FormikInputField from '../../Formik/FormikInputField'
import useViewport, { Viewport } from '../../../hooks/useViewport'
import { FileFormType } from './FileForm'
import { useTranslation } from 'react-i18next'
import FormikTextareaField from '../../Formik/FormikTextareaField'

interface HeaderCardProps {
    id?: string
    formType?: FileFormType
}

function format(value: string = ''): string {
    return value.replace(/[^\w_-]+/g, '')
}

export default function HeaderCard(props: HeaderCardProps): ReactElement {
    const history = useHistory<{ returnBaseUrl: string }>()
    const { t: translate } = useTranslation()

    const { isViewport } = useViewport()
    const { setFieldValue, dirty, submitForm, isSubmitting } = useFormikContext<FileMutationDto>()

    return (
        <Card>
            <Stack horizontal={isViewport('>=', Viewport.MainMenu)} tokens={{ childrenGap: 'm', maxWidth: '100%' }}>
                <Stack grow tokens={{ childrenGap: 's2' }}>
                    <Stack
                        horizontal={isViewport('>=', Viewport.OutlookNewWide)}
                        tokens={{ childrenGap: isViewport('>=', Viewport.OutlookNewWide) ? 'm' : 's2' }}
                    >
                        <StackItem grow={1}>
                            <FormikInputField<FileMutationDto>
                                required
                                labelKey="file.edit.form.header.reference"
                                fieldName="reference"
                                componentProps={{
                                    onChange: (_, data) => setFieldValue('reference', format(data.value)),
                                }}
                            />
                        </StackItem>
                        <StackItem grow={4}>
                            <FormikInputField<FileMutationDto>
                                required
                                labelKey="file.edit.form.header.name"
                                fieldName="name"
                                componentProps={{ autoFocus: true }}
                            />
                        </StackItem>
                    </Stack>
                    <StackItem>
                        <FormikTextareaField<FileMutationDto> labelKey="file.edit.form.header.description" fieldName="description" />
                    </StackItem>
                </Stack>
                <Stack horizontal={isViewport('<', Viewport.MainMenu)} reversed={isViewport('<', Viewport.MainMenu)} tokens={{ childrenGap: 0 }}>
                    <CommandBarButton
                        text={translate('action.save')}
                        iconProps={{ iconName: 'SaveAndClose' }}
                        styles={{ root: { height: '44px' } }}
                        disabled={isSubmitting}
                        onClick={submitForm}
                    />
                    <StackItem grow>
                        <span />
                    </StackItem>
                    <CommandBarButton
                        text={dirty ? translate('action.cancel') : translate('action.back')}
                        iconProps={{ iconName: dirty ? 'Cancel' : 'Back' }}
                        styles={{ root: { height: '44px' } }}
                        disabled={isSubmitting}
                        onClick={() => {
                            history.push(
                                props.formType === FileFormType.Add
                                    ? // Restoring the last page on startup pushes it without state (Router), so the
                                      // return url is gone after a reload; fall back to /file (HAM-4304).
                                      [history.location.state?.returnBaseUrl, '/file'].filter(Boolean).join('/').replaceAll('//', '/')
                                    : `/file/${props.id}`,
                            )
                        }}
                    />
                </Stack>
            </Stack>
        </Card>
    )
}
